"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "m5.5346 21.8992 6.4656-3.2375 6.4656 3.2375-1.081-7.1496 5.077-5.1488-7.1337-1.1812L12.0002 2 8.6723 8.4196 1.5386 9.6008l5.077 5.1488-1.081 7.1496Zm10.3769-3.5157-3.9113-1.9585-3.9113 1.9585.654-4.3251-3.0714-3.1147 4.3155-.7146 2.0132-3.8834 2.0132 3.8834 4.3154.7146-3.0713 3.1147.654 4.3251Z", clipRule: "evenodd" })), 'StarIcon');
